<template>
  <div :class="['plv-ia-popup', customClass]">
    <slot name="others"></slot>
    <div class="plv-ia-popup__wrap">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonPopup',
  props: {
    customClass: {
      type: String,
      default: ''
    }
  },
};
</script>

<style lang="scss">
.plv-ia-popup {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, .3);
  z-index: 90;
}

.plv-ia-popup__wrap {
  width: 400px;
  height: 200px;
  background: #fff;
  box-shadow: 0 4px 15px 0 rgba(0, 37, 90, .25);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  border-radius: 4px;
}

body[data-lang=en] {
  .plv-ia-popup__wrap {
    width: 450px;
  }
}
</style>
